import React, { useState, useEffect } from 'react';
import { Tooltip } from 'reactstrap';
import { API } from './api/API';

const SocialPost = ({ setLoading }) => {
  const [tooltipOpenInsta, setTooltipOpenInsta] = useState(false);
  const [tooltipOpenX, setTooltipOpenX] = useState(false);
  const [error, setError] = useState(null);
  const [fadeOut, setFadeOut] = useState(false);
  const queryParams = new URLSearchParams(window.location.search);

  const igToken = queryParams.get('igToken');
  const xAccessToken = queryParams.get('xAccessToken');
  const xUsername = queryParams.get('xUsername');

  const toggleInsta = () => setTooltipOpenInsta(!tooltipOpenInsta);
  const toggleX = () => setTooltipOpenX(!tooltipOpenX);

  useEffect(() => {
    if (error) {
      const fadeTimer = setTimeout(() => setFadeOut(true), 4000);
      const removeTimer = setTimeout(() => {
        setError(null);
        setFadeOut(false);
      }, 5000);

      return () => {
        clearTimeout(fadeTimer);
        clearTimeout(removeTimer);
      };
    }
  }, [error]);

  const handleInstagramClick = async () => {
    try {
      setLoading(true);
      const query = window.location.search;
      await API.cloneInstagramPosts(query);
      window.location.reload();
    } catch (error) {
      console.error('Instagram import error:', error);
      setError('Failed to import from Instagram.');
    } finally {
      setLoading(false);
    }
  };

  const handleXClick = async () => {
    try {
      setLoading(true);
      const query = window.location.search;
      await API.cloneXPosts(query);
      window.location.reload();
    } catch (error) {
      setError(error.response.data.message || 'Failed to import from X.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      style={{
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        gap: '10px',
      }}
    >
      {error && (
        <div
          className={`alert alert-danger error-flash-message ${
            fadeOut ? 'fade-out' : ''
          }`}
          role="alert"
          style={{
            position: 'absolute',
            top: '0px',
            right: 10,
            zIndex: 999,
            width: 'auto',
            minWidth: '200px',
            transition: 'opacity 1s ease',
            opacity: fadeOut ? 0 : 1,
          }}
        >
          {error}
        </div>
      )}

      <div style={{ cursor: 'pointer', display: 'flex', gap: '10px' }}>
        {igToken && (
          <div onClick={handleInstagramClick}>
            <svg
              width="28"
              height="28"
              fill="#000000"
              viewBox="0 0 256 256"
              xmlns="http://www.w3.org/2000/svg"
              id="instaIcon"
            >
              <path d="M128,84a44,44,0,1,0,44,44A44.04978,44.04978,0,0,0,128,84Zm0,80a36,36,0,1,1,36-36A36.04061,36.04061,0,0,1,128,164ZM172,32H84A52.059,52.059,0,0,0,32,84v88a52.059,52.059,0,0,0,52,52h88a52.059,52.059,0,0,0,52-52V84A52.059,52.059,0,0,0,172,32Zm44,140a44.04978,44.04978,0,0,1-44,44H84a44.04978,44.04978,0,0,1-44-44V84A44.04978,44.04978,0,0,1,84,40h88a44.04978,44.04978,0,0,1,44,44ZM188,76a8,8,0,1,1-8-8A8.00917,8.00917,0,0,1,188,76Z"></path>
            </svg>
            <Tooltip
              isOpen={tooltipOpenInsta}
              target="instaIcon"
              toggle={toggleInsta}
            >
              Import from Instagram
            </Tooltip>
          </div>
        )}

        {/* X */}
        {xAccessToken && xUsername && (
          <div onClick={handleXClick}>
            <svg
              width="28"
              height="28"
              viewBox="0 0 256 256"
              fill="black"
              xmlns="http://www.w3.org/2000/svg"
              id="xIcon"
            >
              <g transform="scale(0.2) translate(0, 20)">
                <path d="M714.163 519.284L1160.89 0H1055.03L667.137 450.887L357.328 0H0L468.492 681.821L0 1226.37H105.866L515.491 750.218L842.672 1226.37H1200L714.137 519.284H714.163ZM569.165 687.828L521.697 619.934L144.011 79.6944H306.615L611.412 515.685L658.88 583.579L1055.08 1150.3H892.476L569.165 687.854V687.828Z" />
              </g>
            </svg>
            <Tooltip isOpen={tooltipOpenX} target="xIcon" toggle={toggleX}>
              Import from X
            </Tooltip>
          </div>
        )}
      </div>
    </div>
  );
};

export default SocialPost;
